import React from 'react';
import { ReactComponent as ChaosPattern } from '../assets/espaces-culturel/ccchaos.svg';

const SkillsChaosBackground = () => (
  <div className="skills-chaos-bg" aria-hidden="true">
    <div className="skills-chaos-bg__stage">
      <ChaosPattern className="skills-chaos-bg__svg" focusable="false" />
    </div>
  </div>
);

export default SkillsChaosBackground;
